import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const OfferOrdering = () => (
  <Box sx={{ backgroundColor: 'secondary.main', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
    <Typography variant="h1" color="white">itau - /app/sales/ordering/offer</Typography>
  </Box>
);

export default OfferOrdering;
